// Compatibility wrapper — re-exports from the shared matching engine.
// The canonical scoring implementation lives in supabase/functions/_shared/matching/scoreEngine.ts
// UI-only helpers (colors, labels) remain here since they have no edge-function use.

export {
  WEIGHTS,
  TOTAL_WEIGHT,
  CRITICAL_CATEGORIES,
  SECONDARY_CATEGORIES,
  DEFAULT_MIN_SCORE,
  WEAK_TOGGLE_MIN_SCORE,
  getMatchLevel,
  isHardMatchValid,
  calculateMatchScore,
  sellerCriteriaToPropertyData,
  scoreBuyerAgainstSeller,
} from '../../supabase/functions/_shared/matching/scoreEngine.ts';

export type {
  PropertyData,
  BuyerCriteria,
  MatchLevel,
  MatchBreakdown,
  MatchScoreResult,
  ComponentResult,
} from '../../supabase/functions/_shared/matching/types.ts';

// ── UI-only helpers (not part of the shared engine) ───────────────────────────

export function getMatchLevelLabel(level: import('../../supabase/functions/_shared/matching/types.ts').MatchLevel): string {
  switch (level) {
    case 'perfect': return 'התאמה מושלמת';
    case 'excellent': return 'התאמה מצוינת';
    case 'strong': return 'התאמה חזקה';
    case 'potential': return 'שווה בדיקה';
    case 'weak': return 'התאמה חלשה';
  }
}

export function getMatchLevelColor(level: import('../../supabase/functions/_shared/matching/types.ts').MatchLevel): string {
  switch (level) {
    case 'perfect': return 'text-green-400';
    case 'excellent': return 'text-green-400';
    case 'strong': return 'text-teal-400';
    case 'potential': return 'text-blue-400';
    case 'weak': return 'text-amber-400';
  }
}

export function getMatchLevelBg(level: import('../../supabase/functions/_shared/matching/types.ts').MatchLevel): string {
  switch (level) {
    case 'perfect': return 'bg-green-600';
    case 'excellent': return 'bg-green-600';
    case 'strong': return 'bg-teal-600';
    case 'potential': return 'bg-blue-600';
    case 'weak': return 'bg-amber-600';
  }
}

// ── Hebrew field labels for breakdown display ─────────────────────────────────
import type { MatchBreakdown } from '../../supabase/functions/_shared/matching/types.ts';
import { WEIGHTS as _W } from '../../supabase/functions/_shared/matching/scoreEngine.ts';

export const BREAKDOWN_LABELS: Record<keyof MatchBreakdown, string> = {
  location: 'מיקום',
  budget: 'תקציב',
  rooms: 'חדרים',
  propertyType: 'סוג נכס',
  size: 'שטח',
  amenities: 'מאפיינים',
  condition: 'מצב הנכס',
};

export const BREAKDOWN_MAX: Record<keyof MatchBreakdown, number> = {
  location: _W.location,
  budget: _W.budget,
  rooms: _W.rooms,
  propertyType: _W.propertyType,
  size: _W.size,
  amenities: _W.amenities,
  condition: _W.condition,
};
